export default "__VITE_PUBLIC_ASSET__df0e4e45__"